export const ANALYTICS_COOKIES = {
  title: 'Analytics Cookies',
  description: 'Collect usage data to improve site functionality.',
  linkedCategory: 'analytics',
  cookieTable: {
    caption: '',
    headers: {
      name: 'Name',
      domain: 'Domain',
      duration: 'Expiration',
      description: 'Description',
    },
    body: [
      // GTM
      {
        name: '_ga_53KB74YDZR',
        domain: 'googletagmanager.com',
        duration: '1 year 1 month 4 days',
        description: 'Google Analytics sets this cookie to store and count page views',
      },
      {
        name: '_ga',
        domain: 'googletagmanager.com',
        duration: '1 year 1 month 4 days',
        description:
          "Google Analytics sets this cookie to calculate visitor, session and campaign data and track site usage for the site's analytics report",
      },
      {
        name: '_gcl_au',
        domain: 'googletagmanager.com',
        duration: '3 months',
        description:
          'Google Tag Manager sets the cookie to experiment advertisement efficiency of websites using their services',
      },
      {
        name: 'FPGSID',
        domain: 'googletagmanager.com',
        duration: '1 hour',
        description:
          'Registers statistical data on users behaviour on the website. Used for internal analytics by the website operator',
      },

      // ANY.RUN
      {
        name: 'user_id',
        domain: 'any.run',
        duration: 'session',
        description: 'Used to improve tracking capabilites of authorized users even after being log out',
      },

      // G2
      {
        name: '_g2_session_id',
        domain: 'g2.com',
        duration: 'session',
        description:
          'Sets a unique ID for the session. This allows the website to obtain data on visitor behaviour for statistical purposes',
      },
      {
        name: 'events_distinct_id',
        domain: 'g2.com',
        duration: 'session',
        description:
          'Sets a unique ID for the session. This allows the website to obtain data on visitor behaviour for statistical purposes',
      },
      {
        name: 'amplitude_session',
        domain: 'g2.com',
        duration: '12 hours',
        description:
          'Sets a unique ID for the session. This allows the website to obtain data on visitor behaviour for statistical purposes',
      },

      // Youtube
      {
        name: 'CONSENT',
        domain: 'youtube.com',
        duration: '2 years',
        description:
          'YouTube sets this cookie via embedded YouTube videos and registers anonymous statistical data',
      },

      // Growthbook
      {
        name: 'gbuuid',
        domain: 'any.run',
        duration: '400 days',
        description: 'Used to serve different content to a client based on split testing',
      },
    ],
  },
};
